import { Box } from "@mui/material";
import ic_apart from "assets/icons/map_menu/ic_apart.svg";
import ic_block from "assets/icons/map_menu/ic_block.svg";
import ic_land from "assets/icons/map_menu/ic_land.svg";
import ic_business from "assets/icons/map_menu/ic_menu_business.svg";
import ic_new from "assets/icons/map_menu/ic_new.svg";
import ic_used from "assets/icons/map_menu/ic_used.svg";
import { EstateTypeNameEnum } from "common/enums/EstateTypeEnum";
import { EstateType } from "common/interfaces/EstateType";
import React, { Fragment, useCallback } from "react";
import styles from "../EstateFilterDialog.module.scss";

export const EstateTypeButtons = React.memo(
  (props: {
    estateTypesMaster: EstateType[];
    estateTypes: EstateType[];
    onEstateTypesChange: (values: EstateType[]) => void;
  }) => {
    const onClick = useCallback(
      (estateType: EstateType) => {
        const newEstateTypes = [...props.estateTypes];

        const foundIndex = newEstateTypes.findIndex(
          (x) => x.id === estateType.id
        );

        if (foundIndex > -1) {
          newEstateTypes.splice(foundIndex, 1);
        } else {
          newEstateTypes.push(estateType);
        }

        props.onEstateTypesChange(newEstateTypes);
      },
      [props]
    );

    return (
      <>
        {props.estateTypesMaster.map((estateType) => {
          const imgSrc =
            estateType.name === EstateTypeNameEnum.土地
              ? ic_land
              : estateType.name === EstateTypeNameEnum.分譲地
              ? ic_block
              : estateType.name === EstateTypeNameEnum.新築建売
              ? ic_new
              : estateType.name === EstateTypeNameEnum.中古戸建
              ? ic_used
              : estateType.name === EstateTypeNameEnum.マンション
              ? ic_apart
              : estateType.name === EstateTypeNameEnum.事業用
              ? ic_business
              : "";

          return (
            <Fragment key={estateType.id}>
              <Box
                className={`${styles.btn_switch01} ${styles.btn_square} ${
                  styles.click_act01
                } ${
                  props.estateTypes.findIndex((x) => x.id === estateType.id) >
                  -1
                    ? styles.on
                    : styles.off
                }`}
                onClick={() => onClick(estateType)}
              >
                <Box component="img" src={imgSrc} alt={estateType.name} />{" "}
                <Box component="span">{estateType.name}</Box>
              </Box>
            </Fragment>
          );
        })}
      </>
    );
  }
);
